import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/login",
            component: () => import("@/view/layout/Layout"),
            children: [
                
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/profile/Profile.vue"),
                    children: [
                        {
                            path: "profile-1",
                            name: "profile-1",
                            component: () =>
                                import("@/view/pages/profile/Profile-1.vue")
                        },
                        {
                            path: "profile-2",
                            name: "profile-2",
                            component: () =>
                                import("@/view/pages/profile/Profile-2.vue")
                        },
                        {
                            path: "profile-3",
                            name: "profile-3",
                            component: () =>
                                import("@/view/pages/profile/Profile-3.vue")
                        },
                        
                    ]
                },
                
                {
                    path: "/roles",
                    name: "roles",
                    component: () =>
                        import("@/view/pages/roles/Roles.vue")
                },
                {
                    path: "/roles/roles-form",
                    name: "roles-form",
                    component: () =>
                        import("@/view/pages/roles/RolesForm.vue")
                },
                
                {
                    path: "/users",
                    name: "users",
                    component: () =>
                        import("@/view/pages/users/Users.vue")
                },
                {
                    path: "/users/users-form",
                    name: "users-form",
                    component: () =>
                        import("@/view/pages/users/UsersForm.vue")
                },
                
                
                {
                    path: "/permissions",
                    name: "permissions",
                    component: () =>
                        import("@/view/pages/permissions/Permissions.vue")
                },
                {
                    path: "/permissions/permissions-form",
                    name: "permissions-form",
                    component: () =>
                        import("@/view/pages/permissions/PermissionsForm.vue")
                },

                {
                    path: "/periods",
                    name: "periods",
                    component: () =>
                        import("@/view/pages/periods/Periods.vue")
                },
                {
                    path: "/periods/periods-form",
                    name: "periods-form",
                    component: () =>
                        import("@/view/pages/periods/PeriodsForm.vue")
                },

                {
                    path: "/transactions",
                    name: "transactions",
                    component: () =>
                        import("@/view/pages/transactions/Transactions.vue")
                },
                {
                    path: "/transactions/transactions-form",
                    name: "transactions-form",
                    component: () =>
                        import("@/view/pages/transactions/TransactionsForm.vue")
                },
                {
                    path: "/transactions_report",
                    name: "transactions_report",
                    component: () =>
                        import("@/view/pages/transactions/TransactionsReport.vue")
                },

                {
                    path: "/transactions_credit_report",
                    name: "transactions_credit_report",
                    component: () =>
                        import("@/view/pages/transactions/TransactionsCreditReport.vue")
                },

                {
                    path: "/parameters",
                    name: "parameters",
                    component: () =>
                        import("@/view/pages/parameters/Parameters.vue")
                },
                {
                    path: "/parameters/parameters-form",
                    name: "parameters-form",
                    component: () =>
                        import("@/view/pages/parameters/ParametersForm.vue")
                },

                {
                    path: "/matches",
                    name: "matches",
                    component: () =>
                        import("@/view/pages/matches/Matches.vue")
                },
                {
                    path: "/matches/matches-form",
                    name: "matches-form",
                    component: () =>
                        import("@/view/pages/matches/MatchesForm.vue")
                },

                {
                    path: "/nopermission",
                    name: "nopermission",
                    component: () =>
                        import("@/view/pages/NoPermission.vue")
                },

                {
                    path: "/stands",
                    name: "stands",
                    component: () =>
                        import("@/view/pages/stands/Stands.vue")
                },
                {
                    path: "/stands/stands-form",
                    name: "stands-form",
                    component: () =>
                        import("@/view/pages/stands/StandsForm.vue")
                },

                {
                    path: "/blocks",
                    name: "blocks",
                    component: () =>
                        import("@/view/pages/blocks/Blocks.vue")
                },
                {
                    path: "/blocks/blocks-form",
                    name: "blocks-form",
                    component: () =>
                        import("@/view/pages/blocks/BlocksForm.vue")
                },

                {
                    path: "/rows",
                    name: "rows",
                    component: () =>
                        import("@/view/pages/rows/Rows.vue")
                },
                {
                    path: "/rows/rows-form",
                    name: "rows-form",
                    component: () =>
                        import("@/view/pages/rows/RowsForm.vue")
                },

                {
                    path: "/seats",
                    name: "seats",
                    component: () =>
                        import("@/view/pages/seats/Seats.vue")
                },
                {
                    path: "/seats/seats-form",
                    name: "seats-form",
                    component: () =>
                        import("@/view/pages/seats/SeatsForm.vue")
                },

                {
                    path: "/user/my_profile",
                    name: "my-profile",
                    component: () =>
                        import("@/view/pages/profile/MyProfile.vue")
                },

                {
                    path: "/user/my_membership",
                    name: "my-membership",
                    component: () =>
                        import("@/view/pages/profile/MyMembership.vue")
                },

                {
                    path: "/passoligs",
                    name: "passoligs",
                    component: () =>
                        import("@/view/pages/passoligs/Passoligs.vue")
                },
                {
                    path: "/passoligs/passoligs-form",
                    name: "passoligs-form",
                    component: () =>
                        import("@/view/pages/passoligs/PassoligsForm.vue")
                },

                {
                    path: "/my_passoligs",
                    name: "my-passoligs",
                    component: () =>
                        import("@/view/pages/my_passoligs/MyPassoligs.vue")
                },
                
                {
                    path: "/my_passoligs/my-passoligs-form",
                    name: "my-passoligs-form",
                    component: () =>
                        import("@/view/pages/my_passoligs/MyPassoligsForm.vue")
                },


                {
                    path: "/tickets",
                    name: "tickets",
                    component: () =>
                        import("@/view/pages/tickets/Tickets.vue")
                },
                {
                    path: "/tickets/tickets-form",
                    name: "tickets-form",
                    component: () =>
                        import("@/view/pages/tickets/TicketsForm.vue")
                },

                {
                    path: "/tickets_report",
                    name: "tickets_report",
                    component: () =>
                        import("@/view/pages/tickets/TicketsReport.vue")
                },

                {
                    path: "/tickets_domestic_away_report",
                    name: "tickets_domestic_away_report",
                    component: () =>
                        import("@/view/pages/tickets/TicketsDomesticAwayReport.vue")
                },

                {
                    path: "/tickets_overseas_away_report",
                    name: "tickets_overseas_away_report",
                    component: () =>
                        import("@/view/pages/tickets/TicketsOverseasAwayReport.vue")
                },

                {
                    path: "/my_tickets",
                    name: "my-tickets",
                    component: () =>
                        import("@/view/pages/my_tickets/MyTickets.vue")
                },
                
                {
                    path: "/my_tickets/my-tickets-form",
                    name: "my-tickets-form",
                    component: () =>
                        import("@/view/pages/my_tickets/MyTicketsForm.vue")
                },

                {
                    path: "/credit_balance",
                    name: "credit_balance",
                    component: () =>
                        import("@/view/pages/CreditBalance.vue")
                },

                {
                    path: "/no_photo",
                    name: "no_photo",
                    component: () =>
                        import("@/view/pages/NoPhoto.vue")
                },

                {
                    path: "/status_error",
                    name: "status_error",
                    component: () =>
                        import("@/view/pages/StatusError.vue")
                },

                {
                    path: "/members",
                    name: "members",
                    component: () =>
                        import("@/view/pages/members/Members.vue")
                },
                {
                    path: "/members/members-form",
                    name: "members-form",
                    component: () =>
                        import("@/view/pages/members/MembersForm.vue")
                },

                {
                    path: "/tickets_for_association_report",
                    name: "tickets_for_association_report",
                    component: () =>
                        import("@/view/pages/tickets/TicketsReportForAssociation.vue")
                },

                {
                    path: "/tickets_for_whatsapp_report",
                    name: "tickets_for_whatsapp_report",
                    component: () =>
                        import("@/view/pages/tickets/TicketsReportWhatsapp.vue")
                },

                {
                    path: "/popups",
                    name: "popups",
                    component: () =>
                        import("@/view/pages/popups/Popups.vue")
                },
                {
                    path: "/popups/popups-form",
                    name: "popups-form",
                    component: () =>
                        import("@/view/pages/popups/PopupsForm.vue")
                },

                {
                    path: "/members_report",
                    name: "members_report",
                    component: () =>
                        import("@/view/pages/members/MembersReport.vue")
                },

                {
                    path: "/credits",
                    name: "credits",
                    component: () =>
                        import("@/view/pages/credits/Credits.vue")
                },
                {
                    path: "/credits/credits-form",
                    name: "credits-form",
                    component: () =>
                        import("@/view/pages/credits/CreditsForm.vue")
                },

                {
                    path: "/members_merged_report",
                    name: "members_merged_report",
                    component: () =>
                        import("@/view/pages/members/MembersMergedReport.vue")
                },

                {
                    path: "/sms_logs",
                    name: "sms_logs",
                    component: () =>
                        import("@/view/pages/sms_logs/SmsLogs.vue")
                },

            ]
        },
        {
            path: "/password_reset",
            name: "password_reset",
            component: () =>
                import("@/view/pages/password_reset/PasswordReset.vue")
        },
        {
            path: "/custom-error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error-1",
                    name: "error-1",
                    component: () => import("@/view/pages/error/Error-1.vue")
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () => import("@/view/pages/error/Error-2.vue")
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue")
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () => import("@/view/pages/error/Error-4.vue")
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () => import("@/view/pages/error/Error-5.vue")
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () => import("@/view/pages/error/Error-6.vue")
                },
                
            ]
        },
        {
            path: "/",
            component: () => import("@/view/pages/auth/login_pages/Login-1"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () =>
                        import("@/view/pages/auth/login_pages/Login-1")
                },
                {
                    name: "register",
                    path: "/register",
                    component: () =>
                        import("@/view/pages/auth/login_pages/Login-1")
                }
            ]
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]
});
